import React, { type FC } from 'react'

import type { Translation } from '../../../../domain'

import { useTranslator } from '../../Internationalization'
import { TextField, type TextFieldProps } from './TextField'

export type TranslatedTextFieldProps = Readonly<{
    label?: Translation
    placeholder?: Translation
    value: string
    onChange: (value: string) => void
}> &
    Pick<TextFieldProps, 'name' | 'id' | 'disabled' | 'required' | 'fullWidth' | 'type' | 'onKeyUp' | 'autoFocus' | 'sx' | 'slotProps' | 'autoComplete'>

export const TranslatedTextField: FC<TranslatedTextFieldProps> = ({ label, placeholder = label, onChange, ...props }) => {
    const translator = useTranslator()
    const translatedLabel = label && translator.formatTranslation(label)

    return (
        <TextField
            label={translatedLabel}
            placeholder={placeholder && translator.formatTranslation(placeholder)}
            onChange={({ target }) => onChange(target.value)}
            {...props}
        />
    )
}
